import React from "react";
import { Button } from "components/ui/button";
import { Link } from "react-router-dom";

const SuccessfulSubmission = ({
  title,
  description,
  buttonText,
  buttonLink,
  onClose,
  onConfirm,
}) => {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="m-auto flex flex-col gap-4 items-center justify-center bg-popover border border-button-generic rounded-xl md:w-[464px] p-6">
        <img src={"/images/misc/success.gif"} alt="Success animation" />
        <div className="flex flex-col gap-1 items-center text-center">
          <p className="text-foreground text-base font-bold leading-6">{title}</p>
          <p className="text-foreground/80 text-base font-normal leading-6">{description}</p>
        </div>
        <div className="w-full flex gap-4">

          <Button
            className="bg-button-generic border border-button-generic rounded-lg text-black w-full text-sm font-medium py-2 px-4 h-9"
            onClick={onClose}
            asChild={!onClose}     // If no callback, default to <Link />
          >
            {onClose ? (
              <div className="flex gap-2 items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
                  <path d="M12 4L4 12M4 4L12 12" stroke="#171717" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Close
              </div>
            ) : (
              <Link to={buttonLink}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
                  <path d="M12 4L4 12M4 4L12 12" stroke="#171717" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Close
              </Link>
            )}
          </Button>

          {/* MAIN BUTTON */}
          <Button
            className="bg-button-coloured rounded-lg text-sm font-medium w-full flex justify-center items-center py-2 h-9"
            onClick={onConfirm}
            asChild={!onConfirm}
          >
            {onConfirm ? (
              <span>{buttonText}</span>
            ) : (
              <Link to={buttonLink}>{buttonText}</Link>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SuccessfulSubmission;
